import * as yup from 'yup';

export const signUpCodeSchema = yup.object().shape({
  code: yup.string().trim().required('Sign-up code is required')
});
